'use client';

import { useCallback, useState } from 'react';

interface ReactNativeWebView {
  postMessage: (message: string) => void;
}

declare global {
  interface Window {
    ReactNativeWebView?: ReactNativeWebView;
  }
}

export const useTossWebView = () => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const closeWebView = useCallback(() => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ name: 'windowClose' }),
    );
  }, []);

  const openConfirmModal = useCallback(() => {
    setIsModalOpened(true);
  }, []);

  const closeConfirmModal = useCallback(() => {
    setIsModalOpened(false);
  }, []);

  const confirmAndClose = useCallback(() => {
    setIsModalOpened(false);
    closeWebView();
  }, [closeWebView]);

  return {
    closeWebView,
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened,
  };
};
